import { render, staticRenderFns } from "./normalText.vue?vue&type=template&id=d3bbc1aa&scoped=true"
import script from "./normalText.vue?vue&type=script&lang=js"
export * from "./normalText.vue?vue&type=script&lang=js"
import style0 from "./normalText.vue?vue&type=style&index=0&id=d3bbc1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bbc1aa",
  null
  
)

export default component.exports